import { render, staticRenderFns } from "./OrganizationChangesTable.vue?vue&type=template&id=4379f64a"
import script from "./OrganizationChangesTable.vue?vue&type=script&lang=ts"
export * from "./OrganizationChangesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports